import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '文章分类', href: '/category' },
      { label: '热门文章', href: '/category' },
      { label: '最新发布', href: '/category' },
    ],
  },
  {
    title: '关于平台',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '创作者入驻', href: '/about' },
      { label: '用户口碑', href: '/about' },
      { label: '联系我们', href: '/about' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '科技数码', href: '/category?cat=tech' },
      { label: '生活随笔', href: '/category?cat=life' },
      { label: '职场成长', href: '/category?cat=career' },
      { label: '教育学习', href: '/category?cat=education' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="font-heading text-2xl text-primary-400 hover:text-primary-300 transition-colors duration-200">
              po文网
            </Link>
            <p className="mt-3 text-sm text-secondary-100/80 leading-relaxed">
              原创文章发布与内容创作平台，汇聚海量优质创作者，让每一篇好文章都被看见。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-medium text-sm text-background-50 mb-4">{group.title}</h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-100/70 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-100/50">
            &copy; 2026 po文网 - 原创文章发布与内容创作平台. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-100/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-secondary-100/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-secondary-100/50 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}